import api from '../../../utils/api'

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Navigate, useNavigate } from 'react-router-dom'




/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import FormServiceOrder from './Form/FormServiceOrder'

function EditServiceOrder({id , btCancelAction, handleOnSuccess}){
    const [serviceOrder, setServiceOrder] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')
    /* const {id} = useParams() */
    
    const {setFlashMessage} = useFlashMessage()
    const navigate = useNavigate()

    useEffect(() => {

        api.get(`/serviceOrder/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
            
        }).then((response) => {
            
            setServiceOrder(response.data.serviceOrder)
        })
    }, [token, id])

    async function updateServiceOrder(serviceOrder) {
        let msgType = 'success'
        
        
        const data = await api.patch(`serviceOrder/update/${serviceOrder._id}`, serviceOrder, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {
            
            return response.data
        }).catch((err) => {
            
            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            /* navigate('/serviceOrder') */
            }

    }


    return (
        <section>
            {serviceOrder._id && (
                <FormServiceOrder
                    title="Editar Ordem de Serviço"
                    handleSubmit={updateServiceOrder}
                    btnText="Salvar"
                    btCancelAction={btCancelAction}
                    serviceOrderData={serviceOrder}
                />
            )}
        </section>
    )
}

export default EditServiceOrder